
import React, { useRef, memo } from 'react';
import Singleton from '../../../core/singleton';
import Popper from 'popper.js';

const ActionButton = props => {
    const { getTradByKey } = Singleton.getInstance();
    let referenceRef = useRef(null);
    let popperRef = useRef(null);
    let arrowRef = useRef(null);

    /** detect when a click event occur outside the popper instance */
    const checkOutSideClick = event => {
        if (referenceRef.current) {
            let isClickInside = (referenceRef.current.contains(event.target) || popperRef.current.contains(event.target));
            if (!isClickInside) {
                document.removeEventListener('click', checkOutSideClick);
                props.onToggle()
            }
        }
    }
    /**
     *  build a popover 
     * more details here https://popper.js.org/
     * */
    const makePoper = () => {
        new Popper(referenceRef.current, popperRef.current, {
            placement: 'left',
            options: {
                closeOnClickOutside: true,
                trigger: 'manual'
            }
        });
        document.addEventListener('click', checkOutSideClick);
    }
    /** returns a list of btn*/
    const Buttons = () => {
        return props.ordersWorkflow.transitions[props.label].map((s, i) => <button onClick={() => props.onChange(s)} key={i} className="btn btn-outline-primary">{getTradByKey(`places.${s}`)}</button>)
    };
    /** returns the popover instance */
    const PopOver = () => {
        (props.open && props.ordersWorkflow.transitions[props.label].length > 0) ? setTimeout(() => makePoper(), 3) : null;
        return (props.open && props.ordersWorkflow.transitions[props.label].length > 0) ? <div ref={popperRef} className="popover bs-popover-left" role="tooltip" >
            <div className="arrow top-calc-50p-minus-12px" ref={arrowRef}></div>
            <div className="popover-body">
                <div className="btn-group-vertical">
                    <Buttons />
                </div>
            </div>
        </div> : null;
    }
    return <div className="w-100">
        <PopOver />
        <button id={props.id} ref={referenceRef} onClick={() => props.onToggle()} className="btn btn-outline-primary w-100 ">
            <i className="fas fa-edit d-md-none" /><span className="d-none d-md-block">{props.ordersWorkflow.waiting_places.includes(props.label) ? getTradByKey('waiting') : getTradByKey(`places.${props.label}`)}</span>
        </button>
    </div>
}
export default memo(ActionButton);